var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames, cPointAtOrigin } from '@shapeable/utils';
import { SvgContainer } from './svg-container';
import { pick } from 'lodash';
import { SvgCircle } from './svg-circle';
import { SvgNodeLabel } from './svg-node-label';
import { SvgImageCircle } from './svg-image-circle';
import { useComponentProps } from '../context/component-props-context';
var cls = classNames('svg-circle-node');
var SvgCircleNodeDefaultProps = {
  label: {
    gap: 10,
    colors: {
      fill: 'black'
    },
    fontSize: 12
  },
  circle: {},
  overlay: {
    colors: {
      fill: 'black'
    },
    opacity: 0
  },
  angle: 90
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    cursor: pointer;\n  "], ["\n    cursor: pointer;\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'SvgCircleNode',
  Container: styled(SvgContainer)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Circle: styled(SvgCircle).attrs(cls.attr('circle'))(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""]))),
  ImageCircle: styled(SvgImageCircle).attrs(cls.attr('image-circle'))(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""]))),
  Label: styled(SvgNodeLabel).attrs(cls.attr('circle'))(templateObject_5 || (templateObject_5 = __makeTemplateObject([""], [""]))),
  Overlay: styled(SvgCircle).attrs(cls.attr('overlay'))(templateObject_6 || (templateObject_6 = __makeTemplateObject([""], [""])))
};
export var SvgCircleNode = function (props) {
  var _a, _b;
  var _c = useComponentProps(My.NAME, SvgCircleNodeDefaultProps, props),
    className = _c.className,
    children = _c.children,
    imageUrl = _c.imageUrl,
    animate = _c.animate,
    id = _c.id,
    isActive = _c.isActive,
    onClick = _c.onClick,
    onMouseOver = _c.onMouseOver,
    x = _c.x,
    y = _c.y,
    delay = _c.delay,
    from = _c.from,
    angle = _c.angle,
    r = _c.r,
    overlay = _c.overlay,
    circle = _c.circle,
    label = _c.label;
  var labelPoint = cPointAtOrigin(0, 0)(r + (label === null || label === void 0 ? void 0 : label.gap), angle);
  var hasOverlay = !!((_a = overlay === null || overlay === void 0 ? void 0 : overlay.colors) === null || _a === void 0 ? void 0 : _a.fill) && (overlay === null || overlay === void 0 ? void 0 : overlay.opacity);
  var CircleComponent = imageUrl ? My.ImageCircle : My.Circle;
  return React.createElement(My.Container, {
    className: cls.name(className),
    x: x,
    y: y,
    animate: animate,
    from: pick(from, 'x', 'y', 'opacity'),
    delay: delay,
    onClick: onClick,
    onMouseOver: onMouseOver,
    isActive: isActive
  }, React.createElement(CircleComponent, {
    colors: circle.colors,
    r: r,
    encode: true,
    strokeWidth: circle.strokeWidth,
    imageUrl: imageUrl,
    id: id || imageUrl,
    isActive: isActive,
    animate: animate,
    from: pick(from, 'r')
  }, React.createElement(My.Label, {
    colors: label.colors,
    fontSize: label.fontSize,
    angle: angle,
    text: label.text,
    isActive: isActive,
    animate: animate,
    x: labelPoint.cx,
    y: labelPoint.cy
  }), hasOverlay && React.createElement(My.Overlay, {
    r: r - (circle.strokeWidth || 0) / 2,
    colors: {
      fill: (_b = overlay === null || overlay === void 0 ? void 0 : overlay.colors) === null || _b === void 0 ? void 0 : _b.fill,
      stroke: 'none'
    },
    opacity: overlay.opacity,
    isActive: isActive,
    animate: animate,
    from: pick(from, 'opacity')
  }), children));
};
SvgCircleNode.cls = cls;
SvgCircleNode.defaults = SvgCircleNodeDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;